import { FlexBox } from "@vp/swan";
import React, { useContext } from "react";

import ShippingCalculatorBuilder from "./ShippingCalculatorBuilder";
import { BffDataContext } from "../../../contexts/BffDataContextProvider";
import { ProductContext } from "../../../contexts/ProductContextProvider";
import CouponCalloutBuilder from "./CouponCalloutBuilder";
import PriceDisplayBuilder from "./PriceDisplayBuilder";

export interface PriceInfoProps {}

const PriceInfo: React.FC<PriceInfoProps> = (props: PriceInfoProps) => {
  const { selectedQuantity, updateInProgress } = useContext(ProductContext);
  const { prices } = useContext(BffDataContext);

  const pricing = prices ? prices[`${selectedQuantity}`] : undefined;

  return (
    <FlexBox className={`${pricing ? "fade-in active " : "fade-in"}`} flexDirection="column">
      <PriceDisplayBuilder />
      <CouponCalloutBuilder />
      {!updateInProgress && <ShippingCalculatorBuilder />}
    </FlexBox>
  );
};

export default PriceInfo;
